import { componentSizesExtraVars } from 'spec';

const componentSizesLaptop = {
  navbar: {
    height: '3.875rem'
  },
  sidebar: {
    opened: {
      width: '14rem'
    },
    closed: {
      width: '4rem'
    }
  },
  fileUploader: '18.563rem',
  adornmentIcon: '1.25rem',
  inputBoxHeight: '2rem',
  filterFieldHeight: '2rem',
  showMoreRowsOfTableButtonHeight: '2rem',
  ...componentSizesExtraVars.common,
  ...componentSizesExtraVars.laptop
};

export default componentSizesLaptop;
